import { FC, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
  sampleGroupAtom,
  taskAtom,
  taskGroupAtom,
  taskQueueAtom,
} from 'packages/at-shell/state/recoil/task';
import { useTaskQueue } from 'packages/task-man/service/pickup';
import { mapAnnotationStateToRole } from 'packages/task-man/service/state-machine';
import { useDoesToolRequireLinkedTasks } from 'packages/at-shell/utils/use-does-tool-require-linked-tasks';
import { useToolLinkedTaskQueryParams } from 'packages/at-shell/utils/multitask-workflow-query-params';
import { useUserProfile } from 'packages/lib/utils/hooks/use-auth-data';
// May-29-2026 Used Cursor (Auto / Claude Opus 4.7 / Sonnet 4.6) to avoid task-queue reload on pickup

export const SyncTaskQueue: FC = () => {
  const task = useRecoilValue(taskAtom);
  const taskGroup = useRecoilValue(taskGroupAtom);
  const sampleGroup = useRecoilValue(sampleGroupAtom);
  const profile = useUserProfile();

  const linkTasksByObject = useDoesToolRequireLinkedTasks();
  const { object_token } = useToolLinkedTaskQueryParams();

  const { data: taskQueue, error: taskQueueError } = useTaskQueue({
    role: mapAnnotationStateToRole(task?.annotationState ?? 'ToDo') ?? 'label',
    annotationState: task?.annotationState,
    sampleGroupToken: sampleGroup?.token,
    userEmail: task?.assignee ?? profile.userProfile?.email,
    taskGroupType: taskGroup?.type,
    loadTasksByObjectToken: linkTasksByObject,
    objectToken: object_token,
  });

  const setTaskQueueAtom = useSetRecoilState(taskQueueAtom);

  // Drop cached queue when navigating to a different task to help avoid bugs when
  // user picks up a new task
  useEffect(() => {
    setTaskQueueAtom(undefined);
  }, [task?.token, setTaskQueueAtom]);

  useEffect(() => {
    if (!task) {
      setTaskQueueAtom(undefined);
      return;
    }
    if (taskQueueError) {
      setTaskQueueAtom(null);
      return;
    }
    if (taskQueue !== undefined) {
      setTaskQueueAtom(taskQueue);
    }
  }, [task, taskQueue, taskQueueError, setTaskQueueAtom]);

  return null;
};
